import { Expose, Type } from "class-transformer";
import { IsArray, IsBoolean, IsEnum, IsInt, IsNumber, IsOptional, IsString } from "class-validator";
import Address from "../../../entities/address.entity";
import { ShopType, ProductDiscounts } from "../../../entities/shop.entity";

export default class CreateShopResource {
  @IsString()
  @IsOptional()
  @Expose({ name: 'group_id' })
  readonly groupId?: string;

  @IsString()
  @IsOptional()
  @Expose({ name: 'contact_email' })
  readonly contactEmail?: string;

  @IsString()
  @IsOptional()
  @Expose({ name: 'image_url' })
  readonly imageUrl?: string | null;

  @IsString()
  readonly label: string;

  @IsString()
  @IsOptional()
  @Expose({ name: 'contractor_id' })
  readonly contractor?: string;

  @IsString()
  @IsOptional()
  @Expose({ name: 'postal_code_file' })
  readonly postalCodeFile?: string;

  @IsString()
  @IsOptional()
  @Expose({ name: 'zip_code_id' })
  readonly zipCode?: string;


  @Expose({ name: 'is_disabled' })
  @IsBoolean()
  readonly isDisabled?: boolean;

  @IsInt()
  @Type(() => Number)
  @IsOptional()
  @Expose({ name: 'prestashop_shop_id' })
  readonly prestashopShopId?: number;

  @IsInt()
  @Type(() => Number)
  @IsOptional()
  @Expose({ name: 'prestashop_address_id' })
  readonly prestashopAddressId?: number;

  @IsString()
  @IsOptional()
  @Expose({ name: 'prestashop_auth_token' })
  readonly prestashopAuthToken?: string;

  @IsString()
  @IsOptional()
  @Expose({ name: 'prestashop_base_url' })
  readonly prestashopBaseUrl?: string;

  @IsInt()
  @Type(() => Number)
  @IsOptional()
  @Expose({ name: 'prestashop_carrier_id' })
  readonly prestashopCarrierId?: number;

  @IsInt()
  @Type(() => Number)
  @IsOptional()
  @Expose({ name: 'prestashop_category_parent_id' })
  readonly prestashopCategoryParentId?: number;

  @IsInt()
  @Type(() => Number)
  @IsOptional()
  @Expose({ name: 'prestashop_currency_id' })
  readonly prestashopCurrencyId?: number;

  @IsInt()
  @Type(() => Number)
  @IsOptional()
  @Expose({ name: 'prestashop_group_shop_id' })
  readonly prestashopGroupShopId?: number;

  @IsInt()
  @Type(() => Number)
  @IsOptional()
  @Expose({ name: 'prestashop_lang_id' })
  readonly prestashopLangId?: number;

  @IsString()
  @IsOptional()
  @Expose({ name: 'prestashop_module_id' })
  readonly prestashopModuleId?: string;

  @IsInt()
  @Type(() => Number)
  @IsOptional()
  @Expose({ name: 'prestashop_canceled_state_id' })
  readonly prestashopCanceledStateId?: number;

  @IsInt()
  @Type(() => Number)
  @IsOptional()
  @Expose({ name: 'prestashop_paid_state_id' })
  readonly prestashopPaidStateId?: number;

  @IsInt()
  @Type(() => Number)
  @IsOptional()
  @Expose({ name: 'prestashop_payment_failed_state_id' })
  readonly prestashopPaymentFailedStateId?: number;

  @IsInt()
  @Type(() => Number)
  @IsOptional()
  @Expose({ name: 'prestashop_waiting_payment_state_id' })
  readonly prestashopWaitingPaymentStateId?: number;

  @IsInt()
  @Type(() => Number)
  @IsOptional()
  @Expose({ name: 'prestashop_customer_group_id' })
  readonly prestashopCustomerGroupId?: number;

  @IsEnum(ShopType)
  readonly type: ShopType;

  @IsInt()
  @Type(() => Number)
  @IsOptional()
  @Expose({ name: 'cancel_time_limit' })
  readonly cancelTimeLimit?: number;

  @IsInt()
  @Type(() => Number)
  @IsOptional()
  readonly shipping?: number;

  @IsInt()
  @Type(() => Number)
  @IsOptional()
  @Expose({ name: 'saving_rate' })
  readonly savingRate?: number;

  @IsInt()
  @Type(() => Number)
  @IsOptional()
  @Expose({ name: 'max_instalments' })
  readonly maxInstalments?: number;

  @IsOptional()
  @Type(() => Address)
  readonly address?: Address | null;

  @IsOptional()
  @IsArray()
  @Expose({ name: 'contact_email_list' })
  readonly contactEmailList?: string[];

  @IsOptional()
  @IsArray()
  @Expose({ name: 'product_discounts' })
  @Type(() => ProductDiscounts)
  readonly productDiscounts?: ProductDiscounts[];

  constructor(init?: CreateShopResource) {
    this.groupId = init?.groupId;
    this.imageUrl = init?.imageUrl;
    this.contactEmail = init?.contactEmail;
    this.label = init?.label!;
    this.contractor = init?.contractor;
    this.postalCodeFile = init?.postalCodeFile;
    this.zipCode = init?.zipCode;
    this.isDisabled = init?.isDisabled;
    this.prestashopAddressId = init?.prestashopAddressId;
    this.prestashopAuthToken = init?.prestashopAuthToken;
    this.prestashopBaseUrl = init?.prestashopBaseUrl;
    this.prestashopCanceledStateId = init?.prestashopCanceledStateId;
    this.prestashopCarrierId = init?.prestashopCarrierId;
    this.prestashopCategoryParentId = init?.prestashopCategoryParentId;
    this.prestashopCurrencyId = init?.prestashopCurrencyId;
    this.prestashopGroupShopId = init?.prestashopGroupShopId;
    this.prestashopLangId = init?.prestashopLangId;
    this.prestashopModuleId = init?.prestashopModuleId;
    this.prestashopPaidStateId = init?.prestashopPaidStateId;
    this.prestashopPaymentFailedStateId = init?.prestashopPaymentFailedStateId;
    this.prestashopShopId = init?.prestashopShopId;
    this.prestashopWaitingPaymentStateId = init?.prestashopWaitingPaymentStateId;
    this.prestashopCustomerGroupId = init?.prestashopCustomerGroupId;
    this.type = init?.type!;
    this.cancelTimeLimit = init?.cancelTimeLimit;
    this.shipping = init?.shipping;
    this.maxInstalments = init?.maxInstalments;
    this.address = init?.address;
    this.contactEmailList = init?.contactEmailList;
    this.productDiscounts = init?.productDiscounts;
  }
}


